/**
 * @generated SignedSource<<ab3dcb6a07a5ca4a06d033ed1d9bd83e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastDeviceInputMode = "SIGNAGE" | "TOUCH";
export type StorecastScreenDashboardChangedSubscription$variables = {
  dashboardId?: string | null;
  screenId: string;
};
export type StorecastScreenDashboardChangedSubscription$data = {
  readonly storecastScreenChange: {
    readonly id: string;
    readonly inputMode: StorecastDeviceInputMode | null;
    readonly name: string;
    readonly showInfo: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"Storecast_storecastScreen">;
  } | null;
};
export type StorecastScreenDashboardChangedSubscription = {
  response: StorecastScreenDashboardChangedSubscription$data;
  variables: StorecastScreenDashboardChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dashboardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "screenId",
    "variableName": "screenId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showInfo",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inputMode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionX",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionY",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "overviewSize",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noteSize",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v16 = [
  (v3/*: any*/),
  {
    "alias": "largeImage",
    "args": [
      {
        "kind": "Literal",
        "name": "minHeight",
        "value": 1080
      },
      {
        "kind": "Literal",
        "name": "minWidth",
        "value": 1080
      }
    ],
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "size",
    "plural": false,
    "selections": [
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v3/*: any*/)
    ],
    "storageKey": "size(minHeight:1080,minWidth:1080)"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Note",
  "kind": "LinkedField",
  "name": "note",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editingMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrgNote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNotePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": (v16/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fontColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includedInSlideshow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fontStyle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageScale",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageTranslateX",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageTranslateY",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remoteImageURL",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "containImage",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/),
    (v10/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v20 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freq",
  "storageKey": null
},
v24 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberValue",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sectionId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "condition",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v37 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "thumbhash",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v13/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlExpiresAt",
        "storageKey": null
      },
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "storageKey": null
  }
],
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "WidgetFileEdge",
  "kind": "LinkedField",
  "name": "files",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v36/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FilePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": (v37/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slideshowDuration",
  "storageKey": null
},
v40 = [
  (v4/*: any*/),
  (v3/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v42 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v33/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 120
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 120
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": "size(minHeight:120,minWidth:120)"
        }
      ],
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "calculateNotCompletedStarted",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v37/*: any*/),
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        (v47/*: any*/),
        (v48/*: any*/),
        (v49/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = [
  (v3/*: any*/)
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        (v47/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "team",
          "plural": false,
          "selections": (v51/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employees",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            (v47/*: any*/),
            (v49/*: any*/),
            (v48/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "myRole",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v55 = [
  (v3/*: any*/),
  (v41/*: any*/),
  (v23/*: any*/),
  {
    "alias": null,
    "args": (v42/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v3/*: any*/),
      (v25/*: any*/),
      {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isTeamScheduleEventOccasion"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v43/*: any*/),
          (v44/*: any*/),
          (v27/*: any*/),
          (v45/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expireAt",
            "storageKey": null
          },
          (v46/*: any*/),
          (v50/*: any*/),
          (v52/*: any*/),
          (v53/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskExecutionCheck",
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              (v43/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "routineOccasion",
                "plural": false,
                "selections": [
                  (v44/*: any*/),
                  (v27/*: any*/),
                  (v3/*: any*/),
                  (v54/*: any*/),
                  (v25/*: any*/),
                  (v50/*: any*/),
                  (v52/*: any*/),
                  (v46/*: any*/),
                  (v45/*: any*/),
                  (v7/*: any*/),
                  (v53/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskCheck",
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": (v51/*: any*/),
                "storageKey": null
              },
              (v29/*: any*/),
              (v31/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      }
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
],
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamSchedule",
  "kind": "LinkedField",
  "name": "dailyTeamSchedule",
  "plural": false,
  "selections": (v55/*: any*/),
  "storageKey": null
},
v57 = [
  (v3/*: any*/),
  (v23/*: any*/),
  (v41/*: any*/),
  {
    "alias": null,
    "args": (v42/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v3/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v45/*: any*/),
          (v53/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskExecutionCheck",
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "routineOccasion",
                "plural": false,
                "selections": [
                  (v45/*: any*/),
                  (v7/*: any*/),
                  (v53/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      }
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
],
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": (v51/*: any*/),
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedStartAtTime",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedEndAtTime",
  "storageKey": null
},
v62 = [
  (v10/*: any*/),
  (v18/*: any*/),
  (v3/*: any*/)
],
v63 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v64 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v65 = [
  (v3/*: any*/),
  (v10/*: any*/)
],
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataSource",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v68 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "parts",
    "storageKey": null
  }
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "changeType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenDashboardChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "storecastScreenChange",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Storecast_storecastScreen"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StorecastScreenDashboardChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "storecastScreenChange",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Dashboard",
                "kind": "LinkedField",
                "name": "dashboards",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "dashboardId",
                "variableName": "dashboardId"
              }
            ],
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "dashboard",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isWidget"
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "type": "WidgetOverview",
                    "abstractKey": "__isWidgetOverview"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/),
                      (v17/*: any*/)
                    ],
                    "type": "WidgetNote",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taskSingleSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "grouping",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineSectionVersion",
                        "kind": "LinkedField",
                        "name": "activeSectionVersions",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ordinal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "assignedTeam",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "task",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Routine",
                            "kind": "LinkedField",
                            "name": "routine",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v21/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v22/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Routine",
                                "kind": "LinkedField",
                                "name": "routine",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Schedule",
                                    "kind": "LinkedField",
                                    "name": "schedule",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RecurrenceRule",
                                        "kind": "LinkedField",
                                        "name": "rules",
                                        "plural": true,
                                        "selections": [
                                          (v23/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v24/*: any*/),
                                "concreteType": "TaskNumberOccasionConnection",
                                "kind": "LinkedField",
                                "name": "occasions",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskNumberOccasionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskNumberOccasion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RoutineOccasion",
                                            "kind": "LinkedField",
                                            "name": "occasion",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v27/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaskExecutionNumber",
                                            "kind": "LinkedField",
                                            "name": "taskExecutions",
                                            "plural": true,
                                            "selections": [
                                              (v28/*: any*/),
                                              (v29/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TaskNumberGoals",
                                                "kind": "LinkedField",
                                                "name": "goals",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "lessThan",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "greaterThan",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v3/*: any*/),
                                              (v30/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "occasions(first:8)"
                              }
                            ],
                            "type": "TaskNumber",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": (v24/*: any*/),
                                "concreteType": "TaskCheckOccasionConnection",
                                "kind": "LinkedField",
                                "name": "occasions",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskCheckOccasionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskCheckOccasion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RoutineOccasion",
                                            "kind": "LinkedField",
                                            "name": "occasion",
                                            "plural": false,
                                            "selections": [
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v3/*: any*/),
                                              (v27/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TaskExecutionCheck",
                                            "kind": "LinkedField",
                                            "name": "taskExecutions",
                                            "plural": true,
                                            "selections": [
                                              (v29/*: any*/),
                                              (v31/*: any*/),
                                              (v3/*: any*/),
                                              (v30/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "occasions(first:8)"
                              }
                            ],
                            "type": "TaskCheck",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTaskSingle",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "size",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetWeatherOccasion",
                        "kind": "LinkedField",
                        "name": "currentOccasion",
                        "plural": false,
                        "selections": [
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "temp",
                            "storageKey": null
                          },
                          (v33/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetWeatherOccasion",
                        "kind": "LinkedField",
                        "name": "occasions",
                        "plural": true,
                        "selections": [
                          (v34/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lowTemp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "highTemp",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetWeather",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "turnpikeSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegrationTurnpike",
                        "kind": "LinkedField",
                        "name": "integration",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IntegrationTurnpikeSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "acceptedTimeAverageInMs",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "accepted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unanswered",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rejected",
                                "storageKey": null
                              },
                              (v35/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetIntegrationTurnpike",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "subWidgets",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v3/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*: any*/),
                              (v11/*: any*/),
                              (v38/*: any*/),
                              (v10/*: any*/),
                              (v39/*: any*/)
                            ],
                            "type": "WidgetFile",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*: any*/),
                              (v12/*: any*/),
                              (v17/*: any*/)
                            ],
                            "type": "WidgetNote",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetSpace",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v19/*: any*/),
                          (v18/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetWithTeams",
                    "abstractKey": "__isWidgetWithTeams"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmployeeRole",
                        "kind": "LinkedField",
                        "name": "roles",
                        "plural": true,
                        "selections": (v40/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetWithRoles",
                    "abstractKey": "__isWidgetWithRoles"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "withoutRoleSelected",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v56/*: any*/)
                            ],
                            "type": "WidgetTeamScheduleContentDaily",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamSchedule",
                                "kind": "LinkedField",
                                "name": "weeklyTeamSchedule",
                                "plural": false,
                                "selections": (v55/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "WidgetTeamScheduleContentWeekly",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamSchedule",
                                "kind": "LinkedField",
                                "name": "monthlyTeamSchedule",
                                "plural": false,
                                "selections": (v55/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "WidgetTeamScheduleContentMonthly",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v56/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamSchedule",
                                "kind": "LinkedField",
                                "name": "weeklyTeamSchedule",
                                "plural": false,
                                "selections": (v57/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamSchedule",
                                "kind": "LinkedField",
                                "name": "monthlyTeamSchedule",
                                "plural": false,
                                "selections": (v57/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "WidgetTeamScheduleContentSummary",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTeamSchedule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetIntegrationFlourishPraiseLeaderboardItem",
                        "kind": "LinkedField",
                        "name": "flourishTeams",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "praise",
                            "storageKey": null
                          },
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetIntegrationFlourishPraise",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v38/*: any*/),
                      (v39/*: any*/)
                    ],
                    "type": "WidgetFile",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Employee",
                        "kind": "LinkedField",
                        "name": "employeesWithShifts",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmployeeShift",
                            "kind": "LinkedField",
                            "name": "shifts",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/),
                              (v3/*: any*/),
                              (v60/*: any*/),
                              (v61/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "durationSeconds",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startAtSecondsFromMidnight",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EmployeeScheduleType",
                                "kind": "LinkedField",
                                "name": "scheduleType",
                                "plural": false,
                                "selections": (v62/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EmployeeScheduleSecondaryType",
                                "kind": "LinkedField",
                                "name": "secondaryScheduleType",
                                "plural": false,
                                "selections": (v62/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetEmployeeSchedule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetEmployeeLeaveItem",
                        "kind": "LinkedField",
                        "name": "employeesOnLeave",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Employee",
                            "kind": "LinkedField",
                            "name": "employee",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v48/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmployeeShift",
                            "kind": "LinkedField",
                            "name": "shifts",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v60/*: any*/),
                              (v61/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LeaveReason",
                                "kind": "LinkedField",
                                "name": "leaveReason",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "leaveReason",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "leaveCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetEmployeeLeave",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v54/*: any*/),
                          (v3/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "integration",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v58/*: any*/)
                    ],
                    "type": "WidgetTodoOverview",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v58/*: any*/),
                      {
                        "alias": "signalContent",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": (v63/*: any*/),
                                "concreteType": "SignalConnection",
                                "kind": "LinkedField",
                                "name": "signals",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SignalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Signal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v10/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "priority",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StoreZonedDate",
                                            "kind": "LinkedField",
                                            "name": "publishedAtDate",
                                            "plural": false,
                                            "selections": (v64/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "employeeReceiverReceiptsCount",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Store",
                                            "kind": "LinkedField",
                                            "name": "store",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "employeeCount",
                                                "storageKey": null
                                              },
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StoreProduct",
                                            "kind": "LinkedField",
                                            "name": "linkedProducts",
                                            "plural": true,
                                            "selections": (v51/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Image",
                                            "kind": "LinkedField",
                                            "name": "descriptionImages",
                                            "plural": true,
                                            "selections": (v51/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "File",
                                            "kind": "LinkedField",
                                            "name": "descriptionFiles",
                                            "plural": true,
                                            "selections": (v51/*: any*/),
                                            "storageKey": null
                                          },
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "cursor",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endCursor",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasNextPage",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__id",
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "signals(first:20)"
                              },
                              {
                                "alias": null,
                                "args": (v63/*: any*/),
                                "filters": null,
                                "handle": "connection",
                                "key": "WidgetSignalOverviewContentMedium__signals",
                                "kind": "LinkedHandle",
                                "name": "signals"
                              }
                            ],
                            "type": "WidgetSignalOverviewContentMedium",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetSignalOverview",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "roleContent",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subscriptionKey",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EmployeeRole",
                                "kind": "LinkedField",
                                "name": "roles",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "team",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v18/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Employee",
                                    "kind": "LinkedField",
                                    "name": "employees",
                                    "plural": true,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "type": "WidgetEmployeeRoleOverviewContentListMedium",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetEmployeeRoleOverview",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "taskSections",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": (v65/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "task",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v3/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Routine",
                                "kind": "LinkedField",
                                "name": "routine",
                                "plural": false,
                                "selections": (v65/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "inProgressTaskExecution",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isTaskExecution"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoutineOccasion",
                                "kind": "LinkedField",
                                "name": "routineOccasion",
                                "plural": false,
                                "selections": [
                                  (v26/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v31/*: any*/)
                                ],
                                "type": "TaskExecutionCheck",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v28/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "formattedNumberValue",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TaskExecutionNumber",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "textValue",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TaskExecutionText",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTaskCollection",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routines",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "ownerTeam",
                            "plural": false,
                            "selections": (v40/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineOccasion",
                            "kind": "LinkedField",
                            "name": "lastCompletedOccasion",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "percentage",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetRoutinePositivePercentage",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": (v65/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoCategoryTeam",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notResolvedCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTodoSummary",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetIntegrationPushAppyLeaderboardItem",
                        "kind": "LinkedField",
                        "name": "leaderboard",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "goal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "progress",
                            "storageKey": null
                          },
                          (v35/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetIntegrationPushAppy",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamScheduleOneOffEvent",
                        "kind": "LinkedField",
                        "name": "events",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startAtFormatted",
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endAtFormatted",
                            "storageKey": null
                          },
                          (v33/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetCalendar",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetKPITile",
                        "kind": "LinkedField",
                        "name": "tiles",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subtitle",
                            "storageKey": null
                          },
                          (v67/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetKPITileTrend",
                            "kind": "LinkedField",
                            "name": "trends",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "change",
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "compareValue",
                                "storageKey": null
                              },
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "graph",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v41/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v68/*: any*/),
                                "type": "WidgetKPITileGraphBar",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v68/*: any*/),
                                "type": "WidgetKPITileGraphSlider",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "negative",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "positive",
                                    "storageKey": null
                                  }
                                ],
                                "type": "WidgetKPITileGraphRegions",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WidgetKPITileGraphGaugePart",
                                    "kind": "LinkedField",
                                    "name": "gaugeParts",
                                    "plural": true,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v67/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mode",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WidgetKPITileGraphGaugeIndicator",
                                    "kind": "LinkedField",
                                    "name": "indicators",
                                    "plural": true,
                                    "selections": [
                                      (v21/*: any*/),
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "WidgetKPITileGraphGauge",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetKPI",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegrationNewsfeed",
                        "kind": "LinkedField",
                        "name": "newsfeed",
                        "plural": false,
                        "selections": [
                          (v59/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetNewsfeedPost",
                        "kind": "LinkedField",
                        "name": "posts",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "body",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetNewsfeed",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetListSection",
                        "kind": "LinkedField",
                        "name": "sections",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetListItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rightText",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "rightTextSuffix",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "info",
                                "plural": true,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isWidgetListItemInfo"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v64/*: any*/),
                                    "type": "StoreZonedDate",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "text",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "italic",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "WidgetListItemInfoText",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetList",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v66/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WidgetTableSheet",
                        "kind": "LinkedField",
                        "name": "sheets",
                        "plural": true,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetTableColumn",
                            "kind": "LinkedField",
                            "name": "columns",
                            "plural": true,
                            "selections": [
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WidgetTableSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WidgetTableRow",
                                "kind": "LinkedField",
                                "name": "headerRow",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WidgetTableCell",
                                    "kind": "LinkedField",
                                    "name": "cells",
                                    "plural": true,
                                    "selections": [
                                      (v67/*: any*/),
                                      (v69/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WidgetTableRow",
                                "kind": "LinkedField",
                                "name": "rows",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WidgetTableCell",
                                    "kind": "LinkedField",
                                    "name": "cells",
                                    "plural": true,
                                    "selections": [
                                      (v67/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "sortValue",
                                        "storageKey": null
                                      },
                                      (v69/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTable",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b8c8f0b4b5fcb356ce6baeb2b65f4b72",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenDashboardChangedSubscription",
    "operationKind": "subscription",
    "text": "subscription StorecastScreenDashboardChangedSubscription(\n  $screenId: ID!\n  $dashboardId: ID\n) {\n  storecastScreenChange(screenId: $screenId) {\n    id\n    name\n    showInfo\n    inputMode\n    ...Storecast_storecastScreen\n  }\n}\n\nfragment AllWidgetsContent_widget on Widget {\n  __isWidget: __typename\n  ... on WidgetSpace {\n    ...WidgetSpace_widgetSpace\n    __typename\n  }\n  ... on WidgetIntegrationFlourishPraise {\n    ...WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise\n    __typename\n  }\n  ... on WidgetFile {\n    ...WidgetFile_widgetFile\n    __typename\n  }\n  ... on WidgetTeamSchedule {\n    ...WidgetTeamSchedule_widget\n    __typename\n  }\n  ... on WidgetEmployeeSchedule {\n    ...WidgetEmployeeSchedule_widgetEmployeeSchedule\n    __typename\n  }\n  ... on WidgetEmployeeLeave {\n    ...WidgetEmployeeLeave_widgetEmployeeLeave\n    __typename\n  }\n  ... on WidgetWeather {\n    ...WidgetWeather_widget\n    __typename\n  }\n  ... on WidgetTodoOverview {\n    ...WidgetTodoOverview_widget\n    __typename\n  }\n  ... on WidgetSignalOverview {\n    ...WidgetSignalOverview_widget\n    __typename\n  }\n  ... on WidgetEmployeeRoleOverview {\n    ...WidgetEmployeeRoleOverview_widget\n    __typename\n  }\n  ... on WidgetNote {\n    ...WidgetNote_widgetNote\n    __typename\n  }\n  ... on WidgetTaskSingle {\n    ...WidgetTaskSingle_widgetTaskSingle\n    __typename\n  }\n  ... on WidgetTaskCollection {\n    ...WidgetTaskCollection_widgetTaskCollection\n    __typename\n  }\n  ... on WidgetRoutineOverview {\n    ...WidgetRoutineOverview_widgetRoutineOverview\n    __typename\n  }\n  ... on WidgetRoutinePositivePercentage {\n    ...WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage\n    __typename\n  }\n  ... on WidgetTodoSummary {\n    ...WidgetTodoSummary_widgetTodoSummary\n    __typename\n  }\n  ... on WidgetCalendarOverview {\n    ...WidgetCalendarOverview_widget\n    __typename\n  }\n  ... on WidgetIntegrationPushAppy {\n    ...WidgetIntegrationPushAppy_widgetIntegrationPushAppy\n    __typename\n  }\n  ... on WidgetIntegrationTurnpike {\n    ...WidgetIntegrationTurnpike_widgetIntegrationTurnpike\n    __typename\n  }\n  ... on WidgetCalendar {\n    ...WidgetCalendar_widgetCalendar\n    __typename\n  }\n  ... on WidgetKPI {\n    ...WidgetKPI_widgetKPI\n    __typename\n  }\n  ... on WidgetNewsfeed {\n    ...WidgetNewsfeed_widgetNewsfeed\n    __typename\n  }\n  ... on WidgetList {\n    ...WidgetList_widgetList\n    __typename\n  }\n  ... on WidgetTable {\n    ...WidgetTable_table\n    __typename\n  }\n}\n\nfragment AllWidgets_widget on Widget {\n  __isWidget: __typename\n  __typename\n  id\n  title\n  ... on WidgetWithTeams {\n    __isWidgetWithTeams: __typename\n    teams {\n      name\n      icon\n      color\n      id\n    }\n  }\n  ... on WidgetWithRoles {\n    __isWidgetWithRoles: __typename\n    roles {\n      name\n      id\n    }\n  }\n  ... on WidgetTeamSchedule {\n    withoutRoleSelected\n  }\n  ...AllWidgetsContent_widget\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment NewsfeedNative_widgetNewsfeed on WidgetNewsfeed {\n  id\n  title\n  posts {\n    ...WidgetNewsfeedPost_widgetNewsfeedPost\n  }\n}\n\nfragment NewsfeedWeb_widgetNewsfeed on WidgetNewsfeed {\n  posts {\n    ...WidgetNewsfeedPost_widgetNewsfeedPost\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment NoteWeb_note on Note {\n  id\n  title\n  isOrgNote\n  noteSize\n  editingMode\n  pages {\n    id\n    image {\n      id\n    }\n    fontColor\n    includedInSlideshow\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment RoutineOccasionStatusCircleInline_RoutineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  deadlineAt\n  startAt\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment SignalOverviewListItemMedium_Signal on Signal {\n  id\n  title\n  priority\n  publishedAtDate {\n    ...StoreFormattedDate\n  }\n  employeeReceiverReceiptsCount\n  store {\n    employeeCount\n    id\n  }\n  linkedProducts {\n    id\n  }\n  descriptionImages {\n    id\n  }\n  descriptionFiles {\n    id\n  }\n}\n\nfragment SingleTaskInProgressCheck_taskExecutionCheck on TaskExecutionCheck {\n  ...taskExecutionListCheckTaskExecutions\n  checkValue\n  updatedAt\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment StorecastHeaderTV_storecast on StorecastScreen {\n  name\n  inputMode\n  store {\n    name\n    dashboards {\n      ...TVDashboardPickerButton_dashboards\n      id\n    }\n    id\n  }\n  dashboard(dashboardId: $dashboardId) {\n    id\n    name\n    ...TVDashboardPickerButton_dashboard\n  }\n}\n\nfragment Storecast_storecastScreen on StorecastScreen {\n  ...StorecastHeaderTV_storecast\n  dashboard(dashboardId: $dashboardId) {\n    id\n    name\n    widgets {\n      id\n      __typename\n      ...useWidgetToPos_widget\n      ...AllWidgets_widget\n    }\n  }\n}\n\nfragment TVDashboardPickerButton_dashboard on Dashboard {\n  id\n  name\n}\n\nfragment TVDashboardPickerButton_dashboards on Dashboard {\n  id\n  ...TVDashboardPickerPopoverDashboards\n}\n\nfragment TVDashboardPickerPopoverDashboards on Dashboard {\n  id\n  ...TVDashboardPickerPopoverItem_dashboard\n}\n\nfragment TVDashboardPickerPopoverItem_dashboard on Dashboard {\n  id\n  name\n}\n\nfragment Tile_kpiTile on WidgetKPITile {\n  title\n  subtitle\n  value\n  unit\n  trends {\n    change\n    label\n    compareValue\n    type\n  }\n  graph {\n    __typename\n    label\n    ... on WidgetKPITileGraphBar {\n      __typename\n      ...Tile_kpiTileGraphBar\n    }\n    ... on WidgetKPITileGraphSlider {\n      __typename\n      ...Tile_kpiTileGraphSlider\n    }\n    ... on WidgetKPITileGraphRegions {\n      __typename\n      ...Tile_kpiTileGraphRegions\n    }\n    ... on WidgetKPITileGraphGauge {\n      __typename\n      ...Tile_kpiTileGraphGauge\n    }\n  }\n}\n\nfragment Tile_kpiTileGraphBar on WidgetKPITileGraphBar {\n  parts\n}\n\nfragment Tile_kpiTileGraphGauge on WidgetKPITileGraphGauge {\n  gaugeParts {\n    color\n    value\n    mode\n  }\n  indicators {\n    type\n    value\n  }\n}\n\nfragment Tile_kpiTileGraphRegions on WidgetKPITileGraphRegions {\n  negative\n  positive\n}\n\nfragment Tile_kpiTileGraphSlider on WidgetKPITileGraphSlider {\n  parts\n}\n\nfragment ToolbarButtonAssignees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ToolbarButtonAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment WidgetCalendarEvent_teamScheduleOneOffEvent on TeamScheduleOneOffEvent {\n  id\n  startAtFormatted\n  startAt\n  endAtFormatted\n  description\n  title\n}\n\nfragment WidgetCalendarOverview_widget on WidgetCalendarOverview {\n  id\n  title\n}\n\nfragment WidgetCalendar_widgetCalendar on WidgetCalendar {\n  id\n  overviewSize\n  events {\n    id\n    ...WidgetCalendarEvent_teamScheduleOneOffEvent\n  }\n}\n\nfragment WidgetEmployeeLeaveItem_item on WidgetEmployeeLeaveItem {\n  id\n  employee {\n    id\n    name\n    image {\n      __typename\n      ...ImagePublicOrPrivate_image\n      ... on Image {\n        id\n      }\n    }\n  }\n  shifts {\n    id\n    startAt\n    endAt\n    formattedStartAtTime\n    formattedEndAtTime\n    leaveReason {\n      id\n      leaveReason\n      leaveCode\n    }\n  }\n}\n\nfragment WidgetEmployeeLeave_widgetEmployeeLeave on WidgetEmployeeLeave {\n  id\n  title\n  employeesOnLeave {\n    id\n    ...WidgetEmployeeLeaveItem_item\n  }\n}\n\nfragment WidgetEmployeeRoleOverviewContent_widget on WidgetEmployeeRoleOverview {\n  roleContent: content {\n    __typename\n    ... on WidgetEmployeeRoleOverviewContentListMedium {\n      subscriptionKey\n      roles {\n        id\n        ...WidgetEmployeeRoleOverviewListItem_role\n      }\n      id\n    }\n  }\n}\n\nfragment WidgetEmployeeRoleOverviewListItem_role on EmployeeRole {\n  id\n  name\n  team {\n    id\n    name\n    color\n  }\n  employees {\n    id\n    name\n    ...Avatar_employee\n  }\n}\n\nfragment WidgetEmployeeRoleOverview_widget on WidgetEmployeeRoleOverview {\n  id\n  title\n  ...WidgetEmployeeRoleOverviewContent_widget\n}\n\nfragment WidgetEmployeeScheduleIcon_widgetEmployeeSchedule on WidgetEmployeeSchedule {\n  provider\n}\n\nfragment WidgetEmployeeScheduleShiftBar on EmployeeShift {\n  status\n  formattedStartAtTime\n  formattedEndAtTime\n  durationSeconds\n  startAtSecondsFromMidnight\n  scheduleType {\n    title\n    color\n    id\n  }\n  secondaryScheduleType {\n    title\n    color\n    id\n  }\n}\n\nfragment WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee on Employee {\n  name\n}\n\nfragment WidgetEmployeeScheduleShiftsEmployee_employee on Employee {\n  id\n  ...WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee\n  shifts {\n    id\n    ...WidgetEmployeeScheduleShiftBar\n  }\n}\n\nfragment WidgetEmployeeSchedule_widgetEmployeeSchedule on WidgetEmployeeSchedule {\n  id\n  overviewSize\n  teams {\n    id\n  }\n  ...WidgetEmployeeScheduleIcon_widgetEmployeeSchedule\n  employeesWithShifts {\n    id\n    shifts {\n      status\n      id\n    }\n    ...WidgetEmployeeScheduleShiftsEmployee_employee\n  }\n}\n\nfragment WidgetFileDynamic_widgetFile on WidgetFile {\n  ...WidgetFileStatic_widgetFile\n  id\n  title\n  files {\n    pages {\n      id\n      ...WidgetFilePage_page\n    }\n    file {\n      id\n      status\n      ...WidgetFilePageProcessing_file\n      name\n    }\n  }\n}\n\nfragment WidgetFilePageProcessing_file on File {\n  status\n}\n\nfragment WidgetFilePage_page on FilePage {\n  id\n  image {\n    id\n    ...Image_image\n  }\n}\n\nfragment WidgetFileStatic_widgetFile on WidgetFile {\n  id\n  title\n  slideshowDuration\n  files {\n    pages {\n      id\n      ...WidgetFilePage_page\n    }\n    file {\n      id\n      status\n      ...WidgetFilePageProcessing_file\n      name\n    }\n  }\n}\n\nfragment WidgetFile_widgetFile on WidgetFile {\n  id\n  files {\n    file {\n      id\n      status\n    }\n  }\n  ...WidgetFileStatic_widgetFile\n  ...WidgetFileDynamic_widgetFile\n}\n\nfragment WidgetIntegrationFlourishPraiseLeaderboardItem on WidgetIntegrationFlourishPraiseLeaderboardItem {\n  id\n  praise\n  title\n}\n\nfragment WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise on WidgetIntegrationFlourishPraise {\n  id\n  overviewSize\n  flourishTeams {\n    id\n    ...WidgetIntegrationFlourishPraiseLeaderboardItem\n  }\n}\n\nfragment WidgetIntegrationPushAppy_widgetIntegrationPushAppy on WidgetIntegrationPushAppy {\n  id\n  title\n  overviewSize\n  leaderboard {\n    id\n    title\n    goal\n    progress\n    total\n  }\n}\n\nfragment WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  acceptedTimeAverageInMs\n}\n\nfragment WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  unanswered\n  rejected\n  total\n}\n\nfragment WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary\n}\n\nfragment WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  acceptedTimeAverageInMs\n}\n\nfragment WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  total\n}\n\nfragment WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  unanswered\n  rejected\n}\n\nfragment WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  total\n}\n\nfragment WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary\n}\n\nfragment WidgetIntegrationTurnpike_widgetIntegrationTurnpike on WidgetIntegrationTurnpike {\n  id\n  turnpikeSize\n  integration {\n    summary {\n      ...WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary\n      ...WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary\n    }\n    id\n  }\n}\n\nfragment WidgetKPI_widgetKPI on WidgetKPI {\n  id\n  title\n  dataSource\n  tiles {\n    ...Tile_kpiTile\n  }\n}\n\nfragment WidgetList_listItemInfo on WidgetListItemInfo {\n  __isWidgetListItemInfo: __typename\n  __typename\n  ... on StoreZonedDate {\n    storeFormattedDate(style: DEFAULT)\n  }\n  ... on WidgetListItemInfoText {\n    text\n    italic\n  }\n}\n\nfragment WidgetList_widgetList on WidgetList {\n  id\n  title\n  dataSource\n  sections {\n    title\n    items {\n      title\n      rightText\n      rightTextSuffix\n      info {\n        __typename\n        ...WidgetList_listItemInfo\n      }\n    }\n  }\n}\n\nfragment WidgetNewsfeedPost_widgetNewsfeedPost on WidgetNewsfeedPost {\n  title\n  body\n  images {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  date\n}\n\nfragment WidgetNewsfeed_widgetNewsfeed on WidgetNewsfeed {\n  title\n  newsfeed {\n    provider\n    id\n  }\n  ...NewsfeedNative_widgetNewsfeed\n  ...NewsfeedWeb_widgetNewsfeed\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n  remoteImageURL\n  containImage\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment WidgetNote_widgetNote on WidgetNote {\n  id\n  note {\n    editingMode\n    isOrgNote\n    pages {\n      id\n    }\n    ...NoteWeb_note\n    ...NoteNative_note\n    id\n  }\n}\n\nfragment WidgetRoutineOverview_widgetRoutineOverview on WidgetRoutineOverview {\n  id\n  title\n}\n\nfragment WidgetRoutinePositivePercentageRoutineItem_routine on Routine {\n  id\n  title\n  ownerTeam {\n    name\n    id\n  }\n  lastCompletedOccasion {\n    endAt\n    percentage\n    id\n  }\n}\n\nfragment WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage on WidgetRoutinePositivePercentage {\n  id\n  title\n  routines {\n    id\n    ...WidgetRoutinePositivePercentageRoutineItem_routine\n  }\n}\n\nfragment WidgetSignalOverviewContentMediumPaginated on WidgetSignalOverview {\n  teams {\n    id\n  }\n  signalContent: content {\n    __typename\n    ... on WidgetSignalOverviewContentMedium {\n      signals(first: 20) {\n        edges {\n          node {\n            id\n            ...SignalOverviewListItemMedium_Signal\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n  id\n}\n\nfragment WidgetSignalOverview_widget on WidgetSignalOverview {\n  id\n  title\n  teams {\n    id\n  }\n  ...WidgetSignalOverviewContentMediumPaginated\n}\n\nfragment WidgetSpace_widgetSpace on WidgetSpace {\n  id\n  title\n  subWidgets {\n    __typename\n    ... on WidgetFile {\n      id\n      height\n      width\n      overviewSize\n      positionX\n      positionY\n      ...WidgetFile_widgetFile\n      __typename\n    }\n    ... on WidgetNote {\n      id\n      height\n      width\n      noteSize\n      positionX\n      positionY\n      ...WidgetNote_widgetNote\n      __typename\n    }\n    id\n  }\n}\n\nfragment WidgetTable_cell on WidgetTableCell {\n  value\n  changeType\n}\n\nfragment WidgetTable_row on WidgetTableRow {\n  cells {\n    ...WidgetTable_cell\n  }\n}\n\nfragment WidgetTable_section on WidgetTableSection {\n  headerRow {\n    ...WidgetTable_row\n  }\n  rows {\n    cells {\n      value\n      sortValue\n    }\n    ...WidgetTable_row\n  }\n}\n\nfragment WidgetTable_sheet on WidgetTableSheet {\n  title\n  columns {\n    label\n  }\n  sections {\n    ...WidgetTable_section\n  }\n}\n\nfragment WidgetTable_table on WidgetTable {\n  id\n  title\n  dataSource\n  sheets {\n    title\n    ...WidgetTable_sheet\n  }\n}\n\nfragment WidgetTaskCollection_widgetTaskCollection on WidgetTaskCollection {\n  id\n  title\n  taskSections {\n    __typename\n    id\n    section {\n      id\n      title\n    }\n    task {\n      __typename\n      id\n      title\n      routine {\n        id\n        title\n      }\n    }\n    inProgressTaskExecution {\n      __typename\n      ...WidgetTaskMultipleRenderTask_taskExecution\n      id\n    }\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck on TaskExecutionCheck {\n  checkValue\n}\n\nfragment WidgetTaskMultipleRenderTaskContent_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ... on TaskExecutionCheck {\n    __typename\n    ...WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck\n  }\n  ... on TaskExecutionNumber {\n    __typename\n    ...WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber\n  }\n  ... on TaskExecutionText {\n    __typename\n    ...WidgetTaskMultipleRenderTaskText_taskExecutionText\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber on TaskExecutionNumber {\n  numberValue\n  formattedNumberValue\n}\n\nfragment WidgetTaskMultipleRenderTaskText_taskExecutionText on TaskExecutionText {\n  textValue\n}\n\nfragment WidgetTaskMultipleRenderTask_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ...WidgetTaskMultipleRenderTaskContent_taskExecution\n  routineOccasion {\n    endAt\n    id\n  }\n}\n\nfragment WidgetTaskSingleCheckSmallInProgress_taskExecutions on TaskExecutionCheck {\n  checkValue\n  ...taskExecutionListCombineCheckTaskExecutions\n}\n\nfragment WidgetTaskSingleCheck_taskCheck on TaskCheck {\n  id\n  title\n  routine {\n    id\n    title\n  }\n  occasions(first: 8) {\n    edges {\n      node {\n        id\n        ...WidgetTaskSingleCheck_taskCheckOccasion\n        taskExecutions {\n          id\n          checkValue\n          sectionId\n          ...WidgetTaskSingleCheckSmallInProgress_taskExecutions\n          ...SingleTaskInProgressCheck_taskExecutionCheck\n        }\n        occasion {\n          id\n          startAt\n          endAt\n          sequenceNumber\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTaskSingleCheck_taskCheckOccasion on TaskCheckOccasion {\n  id\n  occasion {\n    startAt\n    endAt\n    id\n  }\n  taskExecutions {\n    sectionId\n    checkValue\n    id\n  }\n}\n\nfragment WidgetTaskSingleNumberOccasionPage_taskNumber on TaskNumber {\n  id\n  unit\n  title\n  routine {\n    id\n    title\n    type\n    schedule {\n      rules {\n        freq\n      }\n    }\n  }\n  occasions(first: 8) {\n    edges {\n      node {\n        id\n        occasion {\n          id\n          startAt\n          endAt\n          sequenceNumber\n        }\n        taskExecutions {\n          numberValue\n          sectionId\n          goals {\n            lessThan\n            greaterThan\n          }\n          ...useGroupNumberTaskExecution_taskExecutionNumber\n          updatedAt\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTaskSingle_widgetTaskSingle on WidgetTaskSingle {\n  id\n  title\n  grouping\n  taskSingleSize\n  ...useWidgetTaskSingleSections_widgetTaskSingle\n  activeSectionVersions {\n    section {\n      id\n    }\n    id\n  }\n  task {\n    id\n    routine {\n      id\n      type\n      title\n    }\n    __typename\n    ... on TaskNumber {\n      ...WidgetTaskSingleNumberOccasionPage_taskNumber\n    }\n    ... on TaskCheck {\n      ...WidgetTaskSingleCheck_taskCheck\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily on WidgetTeamScheduleContentDaily {\n  dailyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      ...useNowIndexes_teamScheduleEventOccasion\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentList_teamSchedule on TeamSchedule {\n  id\n  label\n  freq\n  events(includeInlineRoutines: true) {\n    __typename\n    id\n    startAt\n    ... on RoutineOccasion {\n      routine {\n        id\n        description\n        descriptionImages {\n          id\n        }\n      }\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      taskExecution {\n        routine {\n          id\n          description\n          descriptionImages {\n            id\n          }\n        }\n        id\n      }\n    }\n    ...useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion\n    ...WidgetTeamScheduleListItem_item\n  }\n}\n\nfragment WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly on WidgetTeamScheduleContentMonthly {\n  monthlyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    ...WidgetTeamScheduleContentStatus_teamSchedule\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentSectionHeader_teamSchedule on TeamSchedule {\n  id\n  freq\n  label\n  ...WidgetTeamScheduleContentStatus_teamSchedule\n}\n\nfragment WidgetTeamScheduleContentStatus_teamSchedule on TeamSchedule {\n  events(includeInlineRoutines: true) {\n    __typename\n    id\n    ... on RoutineOccasion {\n      __typename\n      status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n      ...WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      __typename\n      taskExecution {\n        routineOccasion {\n          status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n          __typename\n          ...WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary on WidgetTeamScheduleContentSummary {\n  dailyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n      ...useNowIndexes_teamScheduleEventOccasion\n    }\n  }\n  weeklyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n  }\n  monthlyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly on WidgetTeamScheduleContentWeekly {\n  weeklyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    id\n  }\n}\n\nfragment WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion on TeamScheduleInlineRoutineOccasion {\n  id\n  taskExecution {\n    id\n    task {\n      id\n    }\n    sectionId\n    routineOccasion {\n      id\n      store {\n        myRole\n        id\n      }\n      sequenceNumber\n      ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion\n      ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion\n      ...RoutineOccasionStatusCircleInline_RoutineOccasion\n    }\n    routine {\n      id\n      ...WidgetTeamScheduleRoutineListItemContent_Routine\n    }\n    checkValue\n  }\n}\n\nfragment WidgetTeamScheduleListItem_item on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  ... on TeamScheduleInlineRoutineOccasion {\n    id\n    startAt\n    taskExecution {\n      routineOccasion {\n        deadlineAt\n        sequenceNumber\n        id\n      }\n      routine {\n        id\n      }\n      id\n    }\n    __typename\n    ...WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion\n  }\n  ... on RoutineOccasion {\n    id\n    __typename\n    startAt\n    deadlineAt\n    sequenceNumber\n    routine {\n      id\n    }\n    ...WidgetTeamScheduleRoutineOccasionListItem_item\n  }\n}\n\nfragment WidgetTeamScheduleRoutineIssueIndicator_routineOccasion on RoutineOccasion {\n  issueCount\n}\n\nfragment WidgetTeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  description\n  title\n  isOrg\n  orgIconUri\n  descriptionImages {\n    size(minHeight: 120, minWidth: 120) {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleRoutineListItemContent_RoutineOccasion on RoutineOccasion {\n  startAt\n  deadlineAt\n  assigned {\n    id\n    employee {\n      id\n      name\n      isLinkedToViewer\n      ...Avatar_employee\n      ...ToolbarButtonAssignees_employees\n      ...ListItemAssignees_employees\n    }\n  }\n  assignedRoles {\n    role {\n      id\n      name\n      isLinkedToViewer\n      employeeIds\n      ...ToolbarButtonAssignees_roles\n      ...ListItemAssignees_roles\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleRoutineOccasionListItem_item on RoutineOccasion {\n  id\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion\n  ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion\n  totalTaskExecutionCount\n  sequenceNumber\n  routine {\n    id\n    ...WidgetTeamScheduleRoutineListItemContent_Routine\n  }\n}\n\nfragment WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true, calculateNotCompletedStarted: true)\n  totalTaskExecutionCount\n}\n\nfragment WidgetTeamSchedule_widget on WidgetTeamSchedule {\n  id\n  overviewSize\n  title\n  teams {\n    id\n    color\n  }\n  content {\n    __typename\n    ... on WidgetTeamScheduleContentDaily {\n      ...WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily\n    }\n    ... on WidgetTeamScheduleContentWeekly {\n      ...WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly\n    }\n    ... on WidgetTeamScheduleContentMonthly {\n      ...WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly\n    }\n    ... on WidgetTeamScheduleContentSummary {\n      ...WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary\n    }\n  }\n}\n\nfragment WidgetTodoOverview_widget on WidgetTodoOverview {\n  id\n  title\n  category {\n    store {\n      myRole\n      id\n    }\n    id\n    title\n    integration\n  }\n  teams {\n    id\n  }\n}\n\nfragment WidgetTodoSummary_widgetTodoSummary on WidgetTodoSummary {\n  id\n  title\n  category {\n    id\n    title\n  }\n  teams {\n    id\n    notResolvedCount\n    team {\n      id\n      name\n      color\n      icon\n    }\n  }\n}\n\nfragment WidgetWeatherBackground_WidgetWeather on WidgetWeather {\n  currentOccasion {\n    condition\n  }\n}\n\nfragment WidgetWeatherConditionIcon_WeatherOccasion on WidgetWeatherOccasion {\n  condition\n}\n\nfragment WidgetWeatherCurrentPane_weatherOccasion on WidgetWeatherOccasion {\n  temp\n  description\n}\n\nfragment WidgetWeatherDatePaneListItem_WeatherOccasion on WidgetWeatherOccasion {\n  date\n  condition\n  lowTemp\n  highTemp\n  ...WidgetWeatherConditionIcon_WeatherOccasion\n}\n\nfragment WidgetWeather_widget on WidgetWeather {\n  id\n  title\n  size\n  ...WidgetWeatherBackground_WidgetWeather\n  currentOccasion {\n    ...WidgetWeatherCurrentPane_weatherOccasion\n  }\n  occasions {\n    date\n    ...WidgetWeatherDatePaneListItem_WeatherOccasion\n  }\n}\n\nfragment taskExecutionListCheckTaskExecutions on TaskExecutionCheck {\n  id\n  sectionId\n  checkValue\n}\n\nfragment taskExecutionListCombineCheckTaskExecutions on TaskExecutionCheck {\n  checkValue\n}\n\nfragment useGroupNumberTaskExecution_taskExecutionNumber on TaskExecutionNumber {\n  id\n  sectionId\n  numberValue\n  updatedAt\n  goals {\n    lessThan\n    greaterThan\n  }\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  fontColor\n  image {\n    id\n  }\n}\n\nfragment useNowIndexes_teamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  startAt\n}\n\nfragment useWidgetTaskSingleSections_widgetTaskSingle on WidgetTaskSingle {\n  activeSectionVersions {\n    id\n    title\n    ordinal\n    section {\n      id\n      assignedTeam {\n        id\n        name\n        color\n        icon\n      }\n    }\n  }\n}\n\nfragment useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  id\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routine {\n        id\n      }\n      id\n    }\n  }\n  ... on RoutineOccasion {\n    routine {\n      id\n    }\n  }\n}\n\nfragment useWidgetToPos_widget on Widget {\n  __isWidget: __typename\n  id\n  positionX\n  positionY\n  ... on WidgetOverview {\n    __isWidgetOverview: __typename\n    overviewSize\n  }\n  ... on WidgetNote {\n    noteSize\n  }\n  ... on WidgetTaskSingle {\n    taskSingleSize\n  }\n  ... on WidgetWeather {\n    size\n  }\n  ... on WidgetIntegrationTurnpike {\n    turnpikeSize\n  }\n  ... on WidgetSpace {\n    subWidgets {\n      __typename\n      id\n      positionX\n      positionY\n      height\n    }\n  }\n  __typename\n}\n"
  }
};
})();

(node as any).hash = "baed89dee596d9f3f79a22997e89f758";

export default node;
